import styled from "styled-components";
import { Image } from "../../../../../raw-components/image/image";

export const LogoImageMrgreenBox = styled(Image)`
    width: 136px;
    height: 98px;
    display: block;
    margin: 0 auto;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        height: 34px;
        width: auto;
    }
`;